import { useMemo } from 'react';
import { Link } from 'react-router';
import { dayTotals, formatHoursValue, secondsToHours } from '@shared/domain/hours.ts';
import { localDate } from '@shared/domain/time.ts';
import { store, useApp } from '../state/store.ts';
import { formatLongDate } from '../lib/format.ts';
import { useNow } from '../components/common.tsx';

/** Hoy: el total del día y una fila por tarjeta con sus horas; tocarla abre la hoja de horas. */
export function TodayPage() {
  const { myLogs, cards, details, openEntry } = useApp();
  const today = localDate(useNow(60_000));
  const day = useMemo(() => dayTotals(myLogs, today), [myLogs, today]);
  const name = (id: string) =>
    (cards.find((c) => c.id === id) ?? details[id])?.name || '(tarjeta no disponible)';

  return (
    <div className="today">
      <h1>Hoy</h1>
      <p className="muted">{formatLongDate(today)}</p>
      <p className="today-total">
        Total del día:{' '}
        <strong data-testid="today-total">{formatHoursValue(secondsToHours(day.seconds))}</strong>
      </p>
      {openEntry && (
        <p className="muted small">
          El cronómetro de «{name(openEntry.card_id)}» sigue corriendo: se suma al detenerlo.
        </p>
      )}
      {day.rows.length === 0 ? (
        <p className="empty">
          Todavía no registras horas hoy. Usa el botón de horas de cada tarea en{' '}
          <Link to="/">Mis tareas</Link>.
        </p>
      ) : (
        <ul className="today-list" aria-label="Horas de hoy">
          {day.rows.map((log) => (
            <li key={log.card_id}>
              <button
                type="button"
                className="today-row"
                data-testid="today-row"
                onClick={() =>
                  store.openHoursSheet({ cardId: log.card_id, withTimer: false, date: today })
                }
              >
                <span className="today-card">{name(log.card_id)}</span>
                <span className="badges">
                  {log.needs_review && <span className="badge badge-warn">Revisar</span>}
                  {log.pending && <span className="badge badge-pending">Pendiente</span>}
                </span>
                <strong className="today-hours">
                  {formatHoursValue(secondsToHours(log.seconds))}
                </strong>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
